import { render, staticRenderFns } from "./LoanTopbar.vue?vue&type=template&id=2a320e18&scoped=true&"
import script from "./LoanTopbar.vue?vue&type=script&lang=ts&"
export * from "./LoanTopbar.vue?vue&type=script&lang=ts&"
import style0 from "./LoanTopbar.vue?vue&type=style&index=0&id=2a320e18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a320e18",
  null
  
)

export default component.exports